import { Box, useTheme } from "@mui/material";
import { Typography } from "@platform/design-system";

const TooltipDocumentUploadStatus = ({ requiredList, optionalList }) => {
  const theme = useTheme();
  const requiredCoverage = requiredList
    ? requiredList.map((item) => item.coverageName)
    : [];
  const optionalCoverage = optionalList
    ? optionalList?.map((item) => item.coverageName)
    : [];

  return (
    <Box>
      <Typography
        key={"required"}
        variant="caption"
        width="200px"
        component="p"
        color="inherit"
      >
        <Typography
          variant="caption"
          component="span"
          color="inherit"
          display="inline-block"
        >
          <strong>Required for:</strong>
        </Typography>
        <Typography component={"p"} variant="caption" color="inherit">
          {requiredCoverage?.join(", ")}
        </Typography>
      </Typography>

      {optionalCoverage?.length > 0 && (
        <Typography
          sx={{ marginTop: theme.spacing(2) }}
          key={"optional"}
          variant="caption"
          width="200px"
          component="p"
          color="inherit"
        >
          <Typography
            variant="caption"
            component="span"
            color="inherit"
            display="inline-block"
          >
            <strong>Optional for:</strong>
          </Typography>
          <Typography component={"p"} variant="caption" color="inherit">
            {optionalCoverage?.join(", ")}
          </Typography>
        </Typography>
      )}
    </Box>
  );
};

export default TooltipDocumentUploadStatus;
